<template>
  <div class="message-body">
    <div class="message-body__heading">
      <div>
        <div>{{ activeMessage.item.heading }}</div>
        <small class="text-muted">{{ activeMessage.item.date }}</small>
      </div>
      <div class="actions">
        <button @click="print" class="btn btn-sm btn-secondary">
          <ui-icon name="print" />
        </button>
        <button @click="$emit('close')" class="btn btn-sm btn-secondary">
          <ui-icon name="close" />
        </button>
      </div>
    </div>
    <table class="table table-striped table-sm">
      <tbody>
        <tr v-for="[key, value] in payload" :key="key">
          <td>{{ formatKey(key) }}</td>
          <td>
            <div class="input-content">
              <div v-if="typeof formatValue(value) === 'object'">
                <pre v-html="formatValue(value)"></pre>
              </div>
              <div v-else v-html="formatValue(value)"></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="message-body__actions">
      <category-control
        :message="activeMessage.item"
        :logs="!showLogs && logs.length > 0"
        @show-logs="showLogs = true"
        @change="$emit('close-update')"
      />
      <message-actions
        :message="activeMessage.item"
        v-if="resend"
        :items="resend"
      />
    </div>
    <div class="message-body__logs" v-if="showLogs">
      <table class="table table-striped table-sm">
        <thead class="thead-dark">
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Created At</th>
            <th>Properties</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in logs" :key="log.id">
            <td>{{ log.log_name }}</td>
            <td>{{ log.description }}</td>
            <td>{{ new Date(log.created_at).toLocaleString('en-US') }}</td>
            <td>{{ log.properties.origin }}:{{ log.properties.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import UiIcon from '../ui-kit/ui-icon.vue'
import CategoryControl from './controls/category-control.vue'
import MessageActions from './controls/message-actions.vue'
import API from '../../../api'
export default {
  name: 'message-body',
  data() {
    return {
      showLogs: false
    }
  },
  components: {
    CategoryControl,
    UiIcon,
    MessageActions
  },
  props: {
    activeMessage: Object
  },
  computed: {
    resend() {
      return this.activeMessage.content.resend
    },
    logs() {
      if (Array.isArray(this.activeMessage.content.logs)) {
        return this.activeMessage.content.logs
      } else if (typeof this.activeMessage.content.logs === 'object') {
        return Object.values(this.activeMessage.content.logs)
      }
    },
    payload() {
      return Object.entries(this.activeMessage.content).filter(([key]) => {
        return key !== 'logs' && key !== 'resend'
      })
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    }
  },
  watch: {
    activeMessage() {
      this.showLogs = false
    }
  },
  methods: {
    formatValue(value) {
      if (Array.isArray(value)) return value.join(', ')
      return value
    },
    formatKey(key) {
      let newKey = key.replaceAll('_', ' ')
      return newKey.charAt(0).toUpperCase() + newKey.slice(1)
    },
    print() {
      let printUrl =
        '/projects/' +
        this.currentProject.id +
        '/forms/' +
        this.activeMessage.item.form_id +
        '/submissions/' +
        this.activeMessage.item.uuid +
        '/print'
      window.location.href = printUrl
    }
  }
}
</script>

<style lang="scss">
.message-body {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  width: calc(100% - 320px);
  height: 100%;
  padding: 1rem;
  overflow: auto;
  background-color: #fff;
  border-left: 1px solid $gray-400;
  box-shadow: 0 -4px 16px rgba(#000, 0.2);

  .input-content {
    word-break: break-word;
  }
  .table {
    td {
      &:first-child {
        white-space: nowrap;
      }
    }
  }
  &__heading {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    .btn {
      display: flex;
      align-items: center;
      margin-left: auto;
      padding: 8px;
    }
    & > * {
      margin-right: 1rem;
      &:last-child {
        margin-right: 0;
      }
    }
    .actions {
      display: flex;
      margin-left: auto;
      & > button:first-child {
        flex: 1 1 auto;
        margin: 0 5px;
      }
    }
  }
  &__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__logs {
    margin-top: 40px;
    font-size: 12px;
    td {
      vertical-align: middle;
    }
    pre {
      margin-bottom: 0;
    }
  }
}
</style>
